import { useQuery } from '@apollo/client/react';
import { OutageTickets } from 'api/outage.types';
import { Wrapper } from 'components/BaseLayout/components/Wrapper';
import { ChildPage } from 'components/ChildPage';
import { Col, Row } from 'components/Grid';
import { InlineAlert } from 'components/InlineAlert';
import { Loader } from 'components/Loader';
import OutageSuccessModal from 'components/Outage/OutageSuccessModal';
import { PageHeader } from 'components/PageHeader';
import { useOutageContext } from 'context/outage/outage.context';
import { getOutageTicketsQuery } from 'graphql/queries/one-app/outage-tickets.query';
import React, { useEffect } from 'react';
import { ContentUtil } from 'utils';

import OutageCard from './OutageCard';
import { content } from './outage-overview.content';

const contentUtil = new ContentUtil({ content, componentName: 'OutageOverview' });

const OutageOverview = () => {
  const { getOutages, outages: selfserviceOutages, error } = useOutageContext();
  const { data, loading } = useQuery<{ getOutageTickets: OutageTickets }>(getOutageTicketsQuery);

  const isPlanned = Boolean(data?.getOutageTickets?.plannedMaintenances?.length);
  const outages = data?.getOutageTickets?.outages || [];

  useEffect(() => {
    if (!loading && !isPlanned) {
      getOutages();
    }
  }, [isPlanned, loading]);

  return (
    <ChildPage>
      <PageHeader title={contentUtil.translateToString('pageTitle')} />
      <Wrapper>
        <Row>
          {loading && <Loader />}
          {!loading && error && (
            <InlineAlert type="error" testid="no-outages-error">
              {contentUtil.translate(error)}
            </InlineAlert>
          )}
          {!loading &&
            !error &&
            outages &&
            outages.map((outage, index) => {
              const selfserviceOutage = selfserviceOutages?.find(
                (selfserviceOutage) => selfserviceOutage.id === outage.ticketId
              );

              return (
                <Col key={`outage-card-${outage.ticketId}`}>
                  <OutageCard
                    outage={outage}
                    isPlanned={isPlanned}
                    subscribed={Boolean(selfserviceOutage?.subscribed)}
                    phoneNumbers={selfserviceOutage?.telephoneNumbers || []}
                    showHeader={index === 0}
                    isSubscribeFormEnabled
                  />
                </Col>
              );
            })}
          <OutageSuccessModal />
        </Row>
      </Wrapper>
    </ChildPage>
  );
};

export default OutageOverview;
